angular.module('zc.projects')

.directive 'zcItemPriceConfirm', ($filter, BaseProjectConfirm) ->
  confirm = new BaseProjectConfirm $filter('translate')('projectsSettings.other.itemPriceConfirm.commodityPrice'), ['item_price']
  confirm.createDirective confirm.requestRecentHistories



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/item_price_confirm.directive.coffee